<dx-data-grid
  [dataSource]="statisticsDataSource"
  [rowAlternationEnabled]="true"
  [showBorders]="true"
  [showColumnLines]="true"
  appNavigateToFirstPageOnSort
  (onRowUpdated)="onRowUpdated($event)"
  #grid
  >
  <dxo-state-storing [savingTimeout]="100" [enabled]="true" type="sessionStorage" [storageKey]="getStorageKey()"></dxo-state-storing>
  <dxo-selection mode="single"></dxo-selection>
  <dxo-load-panel [enabled]="false"></dxo-load-panel>
  <dxo-search-panel placeholder="{{'Shell.generic.search' | translate}}" [visible]="false" [highlightCaseSensitive]="true"></dxo-search-panel>
  <dxo-header-filter [visible]="true"></dxo-header-filter>
  <dxo-filter-row [visible]="true"></dxo-filter-row>
  <dxo-filter-panel [visible]="false"></dxo-filter-panel>
  <dxo-editing mode="cell" [allowUpdating]="canUpdateGraphSettings"></dxo-editing>
  <dxi-column
    caption=" {{ 'Shell.generic.color' | translate }}"
    dataField="color"
    cellTemplate="{{'colorCellTemplate'}}"
    editCellTemplate="colorCellEditTemplate"
    [allowFiltering]="false"
    [allowSorting]="false"
    [allowEditing]="true"
    [showEditorAlways]="canUpdateGraphSettings"
    alignment="left"
    [width]="80">
  </dxi-column>

  <dxi-column
    caption="{{ title }}"
    dataField="serieName"
    dataType="string"
    cellTemplate="{{'serieNameCellTemplate'}}"
    sortOrder="asc"
    [allowFiltering]="false"
    [allowHeaderFiltering]="true"
    [allowEditing]="false"
    [width]="500">
  </dxi-column>

  <dxi-column
    caption=" {{ 'Shell.generic.min' | translate }}"
    dataField="min"
    dataType="number"
    [allowHeaderFiltering]="false"
    [allowFiltering]="true"
    [allowEditing]="false"
    cellTemplate="numericTemplate">
  </dxi-column>

  <dxi-column
    caption=" {{ 'Shell.generic.max' | translate }}"
    dataField="max"
    dataType="number"
    [allowHeaderFiltering]="false"
    [allowFiltering]="true"
    [allowEditing]="false"
    cellTemplate="numericTemplate">
  </dxi-column>

  <dxi-column
    caption=" {{ 'Shell.generic.average' | translate }}"
    dataField="avg"
    dataType="number"
    [allowHeaderFiltering]="false"
    [allowFiltering]="true"
    [allowEditing]="false"
    cellTemplate="numericTemplate">
  </dxi-column>

  <div *dxTemplate="let d of 'colorCellEditTemplate'">
    <dx-color-box [value]="d.value"
      (onValueChanged)="onColorCellValueChanged(d, $event.value)"
      applyButtonText="{{ 'Shell.generic.apply' | translate }}"
      cancelButtonText="{{ 'Shell.generic.cancel' | translate }}">
    </dx-color-box>
  </div>

  <div *dxTemplate="let d of 'serieNameCellTemplate'">
    <span>{{ getSerieNameAndUnitSymbol(d.value) }}</span>
  </div>

  <div class="row" *dxTemplate="let d of 'colorCellTemplate'">
    @if (d.value === '') {
      <span> {{ d.value }}</span>
    }
    <div class="serie-color" [ngStyle]="{ 'background-color': d.value }"></div>
  </div>

  <div *dxTemplate="let data of 'numericTemplate'">
    {{ getFormattedValue(data.value, data.data.resourceClassification) }}
  </div>

</dx-data-grid>
<app-grid-page-selector [grid]="grid"></app-grid-page-selector>
<div [appHideGridFilterPopupOnScrolling]="grid">
